export default __webpack_public_path__ + "assets/016b8046b49205caecf9896885c9c929.png";